// Hotel records, shared by the hotels list, the detail page and the prerender script.

export const hotels = [
  {
    id: 'shinta-mani-shack',
    name: 'Shinta Mani Shack',
    location: 'Siem Reap, Cambodia',
    image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763662393/Shinta_Mani_Shack5_imgupscaler.ai_V1_Fast__2K_khyk4y.png',
    style: 'Contemporary Khmer boutique',
    description: 'Playful design with Khmer motifs, lush courtyard pool and social impact philosophy.',
    detailedDescription: 'Shinta Mani Shack channels the spirit of contemporary Cambodia through bold color, local craftsmanship and genuine hospitality. The 24-room boutique resort celebrates Khmer design vocabulary—intricate wood carvings, silk textiles, temple motifs. The courtyard features a saltwater pool, yoga pavilion and nightly cultural performances. All profits support Shinta Mani Foundation, funding education and healthcare. Staff-led tours to floating villages and artisan workshops offer authentic encounters.',
    amenities: ['Saltwater courtyard pool', 'Yoga & meditation', 'Traditional massage spa', 'Cultural performance venue', 'Artisan gift shop', 'Cooking classes', 'Free WiFi throughout'],
    roomTypes: ['Standard Rooms', 'Deluxe Rooms', 'Garden Suites', 'Pool Suites'],
    bestFor: 'Design-conscious Angkor visitors',
    highlights: ['Social impact foundation', 'Courtyard salt pool', 'Creative interiors'],
    priceRange: 'USD 130–210/night',
    bookingTip: 'Combine with dawn Angkor Wat visit + in-house spa for recovery.',
    bookingUrl: 'https://www.shintamani.com/book',
    bestMonth: 'November to February',
    contact: '+855 63-964 948',
    rating: 4.8
  },
  {
    id: 'danna-langkawi',
    name: 'The Danna Langkawi',
    location: 'Langkawi, Malaysia',
    image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763663146/danna_3_xfc8yb.webp',
    style: 'Colonial-inspired luxury boutique',
    description: 'Elegant colonial-style beachfront retreat blending British-Malaysian charm with modern luxury.',
    detailedDescription: 'The Danna Langkawi epitomizes understated elegance. Built in 1987 but meticulously designed to evoke early 20th-century seaside estates, this 54-room property sits on a private stretch of Burau Bay. Rooms feature high ceilings, natural teak furnishings, and private balconies overlooking tropical gardens or the Andaman Sea. The spa offers traditional treatments blending Malaysian, Thai and Balinese techniques. Fine dining restaurant Pavilion showcases organic local ingredients with international inspiration.',
    amenities: ['Infinity pool', 'Full-service spa', 'Private beach access', 'Multiple restaurants', 'Water sports facilities', 'Yoga studio', 'Library lounge'],
    roomTypes: ['Standard Rooms', 'Deluxe Rooms', 'Suites', 'Villas with private pools'],
    bestFor: 'Couples, relaxed luxury, spa & beach downtime',
    highlights: ['Private calm beach', 'Refined service', 'Award-winning spa', 'Infinity pool'],
    priceRange: 'USD 280–450/night',
    bookingTip: 'Book pool / sea view rooms and consider shoulder season (Apr–Jun) for better rates.',
    bookingUrl: 'https://www.thedannalangkawi.com/booking',
    bestMonth: 'November to March',
    contact: '+60 4-959 1800',
    rating: 4.8
  },
  {
    id: 'majestic-kl',
    name: 'The Majestic Hotel Kuala Lumpur',
    location: 'Kuala Lumpur, Malaysia',
    image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763662698/The_Majestic_Hotel_Kuala_Lumpur1_ozuw7m.webp',
    style: 'Historic colonial grande dame',
    description: 'Iconic 1932 colonial landmark with Art Deco charm and heritage elegance.',
    detailedDescription: 'Built in 1932, The Majestic Hotel Kuala Lumpur stands as a testament to British colonial architecture and Asian hospitality. This 300-room heritage landmark features graceful Art Deco design elements throughout public spaces. The Colonial Wing preserves original 1930s aesthetics while modern Suites offer contemporary comforts. The stunning Orchid Conservatory, home to 600+ species, provides a tranquil retreat. Classic afternoon tea in the lobby lounge remains an institution among KL society.',
    amenities: ['Orchid Conservatory', 'Classical afternoon tea', 'Spa & wellness', 'Multiple dining venues', '24-hour fitness', 'Business center', 'Heritage tours'],
    roomTypes: ['Deluxe Rooms', 'Colonial Wing Rooms', 'Executive Suites', 'Presidential Suites'],
    bestFor: 'Architecture lovers, city explorers',
    highlights: ['Orchid Conservatory', 'Classic afternoon tea', 'Colonial wing ambience'],
    priceRange: 'USD 170–300/night',
    bookingTip: 'Reserve Colonial Wing rooms for most character; weekends fill early.',
    bookingUrl: 'https://www.majestickl.com/reservations',
    bestMonth: 'November to February',
    contact: '+60 3-2785 8000',
    rating: 4.7
  },
  {
    id: 'apsara-rive-droite',
    name: 'The Apsara Rive Droite',
    location: 'Luang Prabang, Laos',
    image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763660779/The_Apsara_Rive_Droite4_imgupscaler.ai_V1_Fast__2K_z1mp1w.png',
    style: 'Riverside boutique (French + Laotian fusion)',
    description: 'Chic nine-room riverside boutique with lush tropical gardens and minimalist design.',
    detailedDescription: 'Apsara Rive Droite redefines boutique luxury on the periphery of UNESCO-listed Luang Prabang. This 18-room sanctuary sits on a quiet riverbank accessible only by vintage wooden boat shuttle—creating an island escape within a cultural heartland. Each room features open-air bathrooms, handwoven textiles and curated local artworks. The property supports local artisans through a social enterprise model. Morning alms ceremonies and guided heritage walks are complimentary.',
    amenities: ['Private boat shuttle', 'Infinity pool overlooking river', 'Spa with traditional massage', 'Farm-to-table restaurant', 'Artisan workshop center', 'Library & reading nooks', 'Photography tours'],
    roomTypes: ['Deluxe Rooms', 'Suites', 'Riverside Villas'],
    bestFor: 'Cultural immersion, slow travel',
    highlights: ['River shuttle', 'Handpicked local art', 'Calm garden pool'],
    priceRange: 'USD 140–220/night',
    bookingTip: 'Request riverside rooms; sunrise river mist is magical.',
    bookingUrl: 'https://www.apsararivedroite.com/book',
    bestMonth: 'October to April',
    contact: '+856 71-253 666',
    rating: 4.9
  },
  {
    id: 'sala-phuket',
    name: 'SALA Phuket Mai Khao Beach Resort',
    location: 'Phuket, Thailand',
    image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763662997/SALA_Phuket_Resort5_woshb6.webp',
    style: 'Contemporary minimal beach villas',
    description: 'Tranquil beachfront resort with private-pool villas and farm-to-table dining.',
    detailedDescription: 'SALA Phuket Mai Khao achieves rare serenity through minimalist design and absolute privacy. The 13 beachfront villas feature floor-to-ceiling glass walls, outdoor rainfall showers, private infinity pools and unobstructed Andaman Sea views. Architectural simplicity—concrete, teak, natural stone—creates a meditative atmosphere. Rooms are intentionally tech-free until evening. The beachfront spa specializes in couple treatments; beach yoga sessions greet sunrise.',
    amenities: ['Private infinity pools', 'Direct beach access', 'Beachfront spa', 'Open-air dining', 'Yoga & meditation', 'Sunset cocktails', 'Stargazing lounge'],
    roomTypes: ['Beachfront Villas', 'Garden Villas', 'Honeymoon Villas'],
    bestFor: 'Private villa stays, honeymooners',
    highlights: ['Secluded beach', 'Outdoor bathrooms', 'Private plunge pools'],
    priceRange: 'USD 260–520/night',
    bookingTip: 'Choose pool villa for full experience; November–early Dec offers value before peak.',
    bookingUrl: 'https://www.salathailand.com/phuket/book',
    bestMonth: 'November to April',
    contact: '+66 76-327 100',
    rating: 4.7
  },
  {
    id: 'library-koh-samui',
    name: 'The Library',
    location: 'Koh Samui, Thailand',
    image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763662816/The_Library_Samui_3_rxsvgo.webp',
    style: 'Minimalist art-driven concept',
    description: 'Conceptual beachfront hotel with iconic red-tiled pool and 1,400-book library.',
    detailedDescription: 'The Library Koh Samui is a work of art masquerading as a hotel. The 40-room property boasts the island\'s most Instagram-worthy feature: a dramatic red mosaic pool overlooking the Gulf. Each room is designed as a unique "story"—The Page, The Secret Library, The Fiction Suite. A curated collection of 1000+ books spans architecture, photography, travel and philosophy. Artist residencies and design talks throughout the year transform the space into an intellectual hub.',
    amenities: ['Iconic red mosaic pool', 'Extensive library', 'Spa & wellness', 'Artist residency program', 'Design talks & workshops', 'Beachfront bar', 'Gourmet restaurant'],
    roomTypes: ['The Page', 'The Fiction Suite', 'The Secret Pool', 'The Author Suite'],
    bestFor: 'Design aficionados, creative retreats',
    highlights: ['Red mosaic pool', 'Curated library', 'Avant-garde suites'],
    priceRange: 'USD 240–430/night',
    bookingTip: 'Book "Secret Pool" or "Page" suites for elevated privacy.',
    bookingUrl: 'https://www.thelibrary.co.th/reservations',
    bestMonth: 'December to February',
    contact: '+66 77-422 767',
    rating: 4.8
  },
  {
    id: 'warehouse-hotel',
    name: 'The Warehouse Hotel',
    location: 'Singapore',
    image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763662273/The_Warehouse_Hotel1_imgupscaler.ai_V1_Fast__2K_oflnsw.png',
    style: 'Industrial heritage riverside',
    description: 'Restored 1895 warehouse on the Singapore River with bespoke lighting and craft cocktails.',
    detailedDescription: 'The Warehouse Hotel is Singapore\'s most architecturally significant contemporary hotel. Housed in a meticulously restored 1895 warehouse, the 37 rooms celebrate raw materials—exposed brick, reclaimed wood, steel beams, concrete—reinterpreted through luxury design. Bespoke lighting installations by international artists illuminate every corner. The ground floor bar serves Singapore Slings crafted with rare spirits. Robertson Quay\'s eclectic restaurants and galleries lie steps away.',
    amenities: ['Heritage architecture tours', 'Craft cocktail bar', 'Statement art installations', 'Riverside restaurant', 'Spa & wellness', 'Business lounge', 'Gallery spaces'],
    roomTypes: ['Loft Rooms', 'Heritage Rooms', 'Warehouse Suites'],
    bestFor: 'Urban weekenders, gastronomy',
    highlights: ['Craft cocktail bar', 'Statement lighting', 'Riverside walks'],
    priceRange: 'USD 250–380/night',
    bookingTip: 'River view rooms worth the premium for evening ambience.',
    bookingUrl: 'https://www.thewarehousehotel.com/rooms',
    bestMonth: 'Year-round (air-conditioned)',
    contact: '+65 6836 3388',
    rating: 4.8
  },
  {
    id: 'fort-bazaar',
    name: 'Fort Bazaar',
    location: 'Galle Fort, Sri Lanka',
    image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763661735/Fort_Bazaar_Galle6_imgupscaler.ai_V1_Fast__2K_fw9xh6.png',
    style: 'Restored spice warehouse boutique',
    description: 'Atmospheric retreat inside UNESCO Galle Fort with central courtyard café and heritage architecture.',
    detailedDescription: 'Fort Bazaar occupies a restored 17th-century spice merchant\'s warehouse within the UNESCO-listed Galle Fort. The 12 rooms feature stone archways, original wooden beams, minimalist furnishings and sea breezes—no television, no clutter. A central courtyard café serves Sri Lankan breakfasts and evening cocktails. Guests wake to calls to prayer echoing from nearby mosques. Fort rampart walks at sunrise, local fishing boat excursions and artisan markets are accessible by foot.',
    amenities: ['Courtyard café', 'Heritage architecture', 'Rampart access', 'Sunrise yoga', 'Fishing excursions', 'Ayurvedic spa', 'Antique library'],
    roomTypes: ['Heritage Rooms', 'Courtyard Suites', 'Rampart View Rooms'],
    bestFor: 'History lovers, slow coastal culture',
    highlights: ['Courtyard café', 'Heritage architecture', 'Walkable fort location'],
    priceRange: 'USD 190–310/night',
    bookingTip: 'Book early for Dec–Feb peak; off-peak offers good value.',
    bookingUrl: 'https://fortbazaarhotel.com/bookings',
    bestMonth: 'November to March',
    contact: '+94 91-222 3320',
    rating: 4.7
  },
  {
    id: 'la-siesta-hanoi',
    name: 'La Siesta Classic Ma May',
    location: 'Hanoi, Vietnam',
    image: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763662060/La_Siesta_Classic_Ma_May2_imgupscaler.ai_V1_Fast__2K_neeneu.png',
    style: 'Boutique Old Quarter classic',
    description: 'Warm service, rooftop bar views and spa treatments in Hanoi\'s lively Old Quarter.',
    detailedDescription: 'La Siesta Classic Ma May proves that Hanoi\'s chaotic Old Quarter can be a sanctuary of calm. The 20-room property occupies a restored colonial shophouse dating to French Indochina. Each room blends traditional Vietnamese aesthetics—silk lanterns, latticed screens, hand-painted motifs—with modern comforts. The rooftop bar overlooks temple roofs and narrow streets. Staff excel at navigating local neighborhoods; the concierge arranges cyclo tours, street food walks and Vietnamese cooking classes.',
    amenities: ['Rooftop bar with city views', 'Traditional spa', 'Cooking class kitchen', 'Bicycle rentals', 'Knowledgeable concierge', 'Tea lounge', 'Local artisan shop'],
    roomTypes: ['Standard Rooms', 'Deluxe Rooms', 'Suite with terrace'],
    bestFor: 'Food + culture exploration',
    highlights: ['Rooftop sunset bar', 'Excellent concierge', 'Spa & massages'],
    priceRange: 'USD 120–200/night',
    bookingTip: 'Ask for upper floors to reduce street noise.',
    bookingUrl: 'https://lasiesta.com.vn/classic-mamay/book',
    bestMonth: 'October to April',
    contact: '+84 24-3935 7338',
    rating: 4.6
  }
];

